import { useState, useEffect } from "react";

const DashedBorder = ({
  radiusDesktop = 32,
  radiusMobile = 32,
  stroke = "#C4BAA3",
  strokeWidth = 1,
  dash = "5,5",
  topOnly = false,
  color
}) => {
  const [radius, setRadius] = useState(radiusDesktop);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setRadius(radiusMobile);
      } else {
        setRadius(radiusDesktop);
      }
    };

    handleResize(); // run on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [radiusDesktop, radiusMobile]);

  const tl = topOnly ? radius : radius;
  const tr = topOnly ? radius : radius;
  const bl = topOnly ? 0 : radius;
  const br = topOnly ? 0 : radius;
  const st = color ? color : stroke

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="absolute inset-0 w-full h-full pointer-events-none"
    >
      <rect
        x={strokeWidth / 2}
        y={strokeWidth / 2}
        width={`calc(100% - ${strokeWidth}px)`}
        height={`calc(100% - ${strokeWidth}px)`}
        fill="none"
        stroke={st}
        strokeWidth={strokeWidth}
        strokeDasharray={dash}
        rx={radius}
        ry={radius}
      />
    </svg>
  );
};

export default DashedBorder;
